export default "__VITE_ASSET__Ddn4OQDj__"